import { render, staticRenderFns } from "./CSCateRootAdd.vue?vue&type=template&id=6ec7ff06&scoped=true"
import script from "./CSCateRootAdd.vue?vue&type=script&lang=js"
export * from "./CSCateRootAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec7ff06",
  null
  
)

export default component.exports